/**
 * Module dependencies.
 */

import { Content, Title, Wrapper } from './accordion.style';
import { JSX, ReactNode } from 'react';

/**
 * `Props` type.
 */

type Props = {
  children?: ReactNode;
  level: 'primary' | 'secondary' | 'terciary';
  name: string;
};

/**
 * Export `Accordion` component.
 */

export function Accordion({ children, level, name }: Props): JSX.Element {
  return (
    <Wrapper>
      <Title level={level}>{name}</Title>

      <Content>{children}</Content>
    </Wrapper>
  );
}
